import { css } from '@emotion/core'
import { CommonTxtBoxStyle, TxtLimit2 } from '@styles/base.style'
import styled, { Theme } from '@themes/theme'

export const selectedMatchH = '87px'

export const SelectLiveMatchWrap = styled.div`
  height: auto;
  max-height: 453px;
  .selected-match {
    padding: 18px 14px 0;
    .selected-match-item {
      height: ${selectedMatchH};
      .selected-match-header {
        position: relative;
        height: 22px;
        min-height: 22px;
        padding: 0 6px;
        font-size: ${props => props.theme.font.tiny};
        .sports-ico {
          img {
            width: 13px;
            margin-right: 5px;
          }
        }
        .select-type {
           font-size: ${props => props.theme.font.tiny};
        }
      }
      .match-status {
        height: 22px;
        .live-spot {
          transform: translate3d(0, 0, 0);
        }
      }
      .selected-match-body {
        padding: 0 6px;
        .team-info {
          &:first-of-type {
            margin-bottom: 0;
          }
        }
        img {
          max-width: 15px;
          max-height: 15px;
          margin-right: 3px;
        }
        &.no-data {
          align-items: center;
          color: ${props => props.theme.color.modalTxt};
        }
      }
      .delete-btn {
        position: absolute;
        top: 50%;
        right: 10px;
        width: 18px;
        height: 18px;
        transform: translate(10px, -50%);
        .cls-ico {
          position: relative;
          display: block;
          &::before, &::after {
            content:'';
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: ${props => props.theme.color.themeTxt};
          }
          &::before {
            width: 9px;
            height: 1px;
          }
          &::after {
            width: 1px;
            height: 9px;
          }
        }
      }
    }
    .delete-all-btn {
      width: 100%;
      height: 30px;
      margin-top: -1px;
      color: ${props => props.theme.color.subBg};
      font-size: ${props => props.theme.font.small};
      font-weight: ${props => props.theme.fontW.medium};
      background: none;
      border-radius: 0;
      border: 1px solid #D7D9DC;
      .delete-ico {
        width: 10px;
        height: auto;
        margin-right: 4px;
      }
      &.disabled {
        color: ${props => props.theme.color.modalDarkBg};
        background: ${props => props.theme.color.modalBg};
        .delete-ico {
          opacity: .3;
        }
      }
    }
  } /* selected-match */
  .live-match {
    height: auto;
    padding: 0 14px 30px;
    background: ${props => props.theme.color.modalBg};
    .league-info {
      padding: 10px 7px 5px;
      text-align: left;
      img {
        width: auto;
        height: 12px;
        margin-right: 4px;
      }
      .country, .league-name {
        margin-right: 10px;
        color: ${props => props.theme.color.modalTxt};
      }
    }
    .match-list {
      &--item {
        margin-bottom: 4px;
        .select-match-btn {
          z-index: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 48px;
          padding: 0 14px;
          background: ${props => props.theme.color.themeTxt};
          border-radius: 6px;
          .team-name {
            ${CommonTxtBoxStyle};
            ${TxtLimit2};
            flex: 1;
            color: ${props => props.theme.color.modalTxt};
            font-size: ${props => props.theme.font.small};
            font-weight: ${props => props.theme.fontW.medium};
            &.home-team {
              text-align: left;
            }
            &.away-team {
              text-align: right;
            }
          }
          .score {
            min-width: 24px;
            margin: 0 3px;
            text-align: center;
            color: ${props => props.theme.color.modalTxt};
            font-size: ${props => props.theme.font.large};
            &.win {
              color: ${props => props.theme.color.red};
            }
            .volleyball-bracket {
              color: ${props => props.theme.color.modalTxt};
              font-size: ${props => props.theme.font.large};
            }
          }
          .period-score {
            margin: 0 3px;
            text-align: center;
            color: ${props => props.theme.color.modalTxt};
            font-size: ${props => props.theme.font.large};
            &.home-score {
              margin-left: -2px;
            }
            &.away-score {
              margin-right: -2px;
            }
          }
          .status-wrap {
            width: auto;
            height: auto;
            margin: 0 4px;
            .status {
              display: inline-flex;
              justify-content: center;
              align-items: center;
              min-width: 38px;
              width: auto;
              height: 24px;
              line-height: 2.4rem;
              padding: 0 5px;
              color: ${props => props.theme.color.modalTxt};
              font-size: ${props => props.theme.font.small};
              font-weight: ${props => props.theme.fontW.medium};
              border-radius: 6px;
              background: ${props => props.theme.color.modalBg};
            }
          }
        } /* select-match-btn */
      }
    } /* match-list */
  } /* live-match */
`
export const LiveMatchItemListWrap = styled.div`
  overflow: auto;
  height: 300px;
  background: #ddd;
`
export const AllTxtStyle = (theme:Theme) => css`
  position: relative;
  &::before {
    content: '';
    display: block;
    z-index: -1;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -52%);
    width: 24px;
    height: 24px;
    background: ${theme.color.mainBg};
    border-radius: 50%;
  }
`
